import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "component-variable__values__value"
};
const _hoisted_2 = { key: 0 };
import { computed, toRef } from "vue";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { useDefaultVariant } from "src/shared/store/component-built/composables/useDefaultVariant";
import { getCampaignComponentVariableDefaultValue } from "src/shared/store/campaign-component/variable/model/campaign-component-variable-value-defaults";
import StringComponentVariablePreviewValue from "./string/StringComponentVariablePreviewValue.vue";
import { useRawVariantValue } from "./useRawVariantValue";
import { useResolvedWorkingVariant } from "./useResolvedWorkingVariant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariablePreviewValue',
    props: {
        componentMutableKey: {},
        variableName: {},
        variant: {},
        variantDisplayMode: {}
    },
    emits: ["focus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { componentVariableMutable } = useComponentVariableMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const emit = __emit;
        const componentId = computed(() => {
            var _a;
            return (_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.getComponentId();
        });
        const { defaultVariant } = useDefaultVariant(componentId);
        const defaultProvidedValue = computed(() => {
            if (!componentVariableMutable.value) {
                return undefined;
            }
            return getCampaignComponentVariableDefaultValue(componentVariableMutable.value.getType());
        });
        const { resolvedWorkingVariant } = useResolvedWorkingVariant(toRef(props, "variant"), defaultVariant, componentVariableMutable);
        const { rawVariantValue } = useRawVariantValue(toRef(props, "variant"), resolvedWorkingVariant, componentVariableMutable, () => props.variantDisplayMode);
        return (_ctx, _cache) => {
            return (_unref(componentVariableMutable) && _unref(defaultVariant) && _unref(resolvedWorkingVariant))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(componentVariableMutable) && defaultProvidedValue.value !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_unref(componentVariableMutable).getType() === 'STRING')
                                ? (_openBlock(), _createBlock(StringComponentVariablePreviewValue, {
                                    key: 0,
                                    "component-id": _unref(componentVariableMutable).getComponentId(),
                                    variant: _unref(resolvedWorkingVariant),
                                    value: _unref(rawVariantValue),
                                    onFocus: _cache[0] || (_cache[0] = ($event) => (emit('focus')))
                                }, null, 8 /* PROPS */, ["component-id", "variant", "value"]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
